var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allCiders !== null)?_c('CardTimeline',{staticClass:"ml-2 mr-2",staticStyle:{"min-width":"20vw","max-height":"calc(100vh - 128px)","overflow-y":"auto"},attrs:{"all-ciders":_vm.allCidersPrepped,"tables":_vm.tables,"kategorien":_vm.kategorien,"is-card":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }